// The order of the blocks of related records on a single (R-U20): the section's saved order first, the blocks it does not name after
// them in the order of the fields — a relation field added later shows up at the end instead of hiding.

import type { FieldDef, TypeBlocks } from '@confdeck/core-shared';

export function orderBlocks(fields: FieldDef[], order: string[] | undefined): FieldDef[] {
  const at = new Map((order ?? []).map((k, i) => [k, i]));
  const named = fields.filter((f) => at.has(f.key)).sort((a, b) => at.get(a.key)! - at.get(b.key)!);
  return [...named, ...fields.filter((f) => !at.has(f.key))];
}

/** The section's blocks after a change: the whole order is kept, so a block added later keeps the place it was moved to. */
export const nextBlocks = (cur: TypeBlocks | null | undefined, patch: Partial<TypeBlocks>): TypeBlocks => ({ order: patch.order ?? cur?.order ?? [], brief: patch.brief ?? cur?.brief ?? [] });
